import * as React from 'react'
import moment from 'moment'
import { useFormatTime } from '~/hooks/useFormatTime'

export function DueAtCell({ row }) {
  const request = row.original
  const isPastDue = moment(request.due_at).isBefore(moment()) // Check if due_at is in the past
  const formatTime = useFormatTime()

  return (
    <span className={isPastDue ? 'text-red-500' : ''}>
      {`${formatTime(request.due_at, 'short')} ${formatTime(request.due_at, 'time')}`}
    </span>
  )
}
